module.exports = __webpack_public_path__ + "img/oval-small.2d328c15.png";